<template>
  <div>
    <NavigationHeader />

    <slot />


  </div>
</template>
<script setup>
definePageMeta({
  layout: "mobile",
});



</script>
